import { Checkbox, FormField, Label, LabeledControl } from '@zillow/constellation-10';

type Props = {
  checked: boolean;
  onClick: () => void;
};

export default function LeaseAttachedCheckbox({ ...props }: Props) {
  return (
    <FormField
      label={<Label optional>Attach an email link of my signed lease</Label>}
      control={
        <LabeledControl
          label={
            <Label>By clicking this box, I agree to receive an email link to my signed lease sent via email</Label>
          }
          control={<Checkbox {...props} />}
        />
      }
    />
  );
}
